// Drug Category Actions
// And update the action creator to use these constants
import axios from 'axios';

export const drugCategoryActions = {
  FETCH_CATEGORIES: {
    REQUEST: 'categories/fetch-categories-request',
    SUCCESS: 'categories/fetch-categories-success',
    FAILURE: 'categories/fetch-categories-failure'
  }
};

// Drugs Actions
export const drugsActions = {
  FETCH_DRUGS: {
    REQUEST: 'drugs/fetch-drugs-request',
    SUCCESS: 'drugs/fetch-drugs-success',
    FAILURE: 'drugs/fetch-drugs-failure'
  },
  FETCH_DRUG_BY_ID: {
    REQUEST: 'drugs/fetch-drug-by-id-request',
    SUCCESS: 'drugs/fetch-drug-by-id-success',
    FAILURE: 'drugs/fetch-drug-by-id-failure'
  },
  DELETE_DRUG: {
    REQUEST: 'drugs/delete-drug-request',
    SUCCESS: 'drugs/delete-drug-success',
    FAILURE: 'drugs/delete-drug-failure'
  }
};

// Then add the delete action creator
export const deleteDrug = (drugId) => async (dispatch) => {
  try {
    dispatch({ type: drugsActions.DELETE_DRUG.REQUEST });

    const response = await fetch(`/medication/drugs/${drugId}/delete/`, {
      method: 'DELETE'
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.detail || 'Failed to delete drug');
    }

    dispatch({
      type: drugsActions.DELETE_DRUG.SUCCESS,
      payload: { id: drugId }
    });

    return { success: true };
  } catch (error) {
    dispatch({
      type: drugsActions.DELETE_DRUG.FAILURE,
      payload: error.message
    });

    return { error };
  }
};

// Drug Upload Actions
export const drugUploadActions = {
  UPLOAD_DRUG: {
    REQUEST: 'drug_upload/upload-drug-request',
    SUCCESS: 'drug_upload/upload-drug-success',
    FAILURE: 'drug_upload/upload-drug-failure'
  },
  UPDATE_DRUG: {
    REQUEST: 'drug_upload/update-drug-request',
    SUCCESS: 'drug_upload/update-drug-success',
    FAILURE: 'drug_upload/update-drug-failure'
  }
}; // Make sure to import axios if not already imported

// Add this action creator to your drugActions.js file
export const updateDrug = (drugId, formData) => async (dispatch) => {
  try {
    dispatch({ type: drugUploadActions.UPDATE_DRUG.REQUEST });

    const config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    };

    const response = await axios.patch(
			// Changed from put to patch
			`/medication/drug/${drugId}/`,
			formData,
			config
    );

    dispatch({
      type: drugUploadActions.UPDATE_DRUG.SUCCESS, // Use constant
      payload: response.data
    });

    return { success: true, data: response.data };
  } catch (error) {
    dispatch({
      type: drugUploadActions.UPDATE_DRUG.FAILURE, // Use constant
      payload:
				error.response && error.response.data.detail
				  ? error.response.data.detail
				  : error.message
    });

    return { error };
  }
};
